import { MILLISECONDS_PER_SECOND } from 'utils/units'

const QUERY_STALE_SECONDS = 300
const PROCESSING_QUERY_REFETCH_SECONDS = 5

/** Shared query freshness and refetch policy. Durations are in milliseconds. */
export const QUERY_STALE_TIME_MS = QUERY_STALE_SECONDS * MILLISECONDS_PER_SECOND
export const QUERY_RETRY_COUNT = 1
export const PROCESSING_QUERY_REFETCH_INTERVAL_MS = PROCESSING_QUERY_REFETCH_SECONDS * MILLISECONDS_PER_SECOND
